import React from "react";
import { Modal, Button } from "reactstrap";
import { formatDateToString } from "../../utils/functions";

const DeleteModal = ({ open, setOpen, rowToDelete, delFunc }) => {
  return (
    <Modal
      className="modal-dialog-centered"
      size={"lg"}
      isOpen={open.Delete}
      toggle={() => setOpen({ ...open, Delete: !open.Delete })}
    >
      <div className="modal-header">
        <h3 className="modal-title" id="exampleModalLabel">
          Obriši unos
        </h3>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => setOpen({ ...open, Delete: !open.Delete })}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="mx-auto">
        <h2 className="ml-4 ml-sm-0">Jeste li sigurni da želite obrisati unos u dnevniku?</h2>
        <ul>
          <li>
            Struka:{" "}
            <span className="font-weight-bold"> {rowToDelete.Struka}</span>
          </li>
          <li>
            Datum upis:{" "}
            <span className="font-weight-bold">
              {" "}
              {formatDateToString(rowToDelete.DatumUpis)}
            </span>
          </li>
          <li>
            Vremenski uvjeti:{" "}
            <span className="font-weight-bold">
              {rowToDelete.VremenskiUvjeti}
            </span>
          </li>
          <li>
            Temperatura1:{" "}
            <span className="font-weight-bold">
              {rowToDelete.Temperatura1} °C
            </span>
          </li>
          <li>
            Temperatura2:{" "}
            <span className="font-weight-bold">
              {rowToDelete.Temperatura2} °C
            </span>
          </li>
          <li>
            Vodostaj:{" "}
            <span className="font-weight-bold"> {rowToDelete.Vodostaj} m</span>
          </li>
          <li>
            Zaposlenici:{" "}
            <span className="font-weight-bold">
              {" "}
              {rowToDelete.Zaposlenici.map((item) => item.label + ", ")}{" "}
            </span>
          </li>{" "}
          <li>
            Strojevi:{" "}
            <span className="font-weight-bold">
              {" "}
              {rowToDelete.Strojevi.map((item) => item.label + ", ")}{" "}
            </span>
          </li>
          <li>
            Upis voditelja:{" "}
            <span className="font-weight-bold">
              {rowToDelete.UpisVoditelja}
            </span>
          </li>
          <li>
            Upis nadzora:{" "}
            <span className="font-weight-bold"> {rowToDelete.UpisNadzora}</span>
          </li>
        </ul>
        <Button
          className="mx-auto my-2 d-flex"
          color="danger"
          onClick={delFunc}
        >
          Obriši
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteModal;
